import { useState } from "react";

type CrossLobCard = {
  title?: string;
  href?: string;
};

type CrossLobSection = {
  key?: string;
  title?: string;
  cards?: CrossLobCard[];
};

type CrossLobLinksProps = {
  /** Preferred: sections built from Flights LOB APIs */
  crossLobSections?: CrossLobSection[] | null;
  /** @deprecated legacy static Strapi shape — still accepted for safety */
  crossLobLinks?: CrossLobSection[] | null;
  gridClassName?: string;
};

function CrossLobSectionBlock({
  section,
  gridClassName = "grid4",
}: {
  section: CrossLobSection;
  gridClassName?: string;
}) {
  const [showViewMore, setShowViewMore] = useState(true);
  const cards = section?.cards || [];

  if (!cards.length) return null;

  return (
    <>
      <div className="separator"></div>
      {section?.title ? <h2 className="h2">{section.title}</h2> : null}
      <ul
        className={`capSulesList ${gridClassName} ${
          !showViewMore ? "showAll" : ""
        }`}
      >
        {cards.map((card, index) => (
          <li
            key={`${card?.href || card?.title || ""}${index}`}
            className="capsule"
          >
            <a href={card?.href}>{card?.title}</a>
          </li>
        ))}
      </ul>
      {cards.length > 4 ? (
        <p className="viewMore">
          <a
            className="viewMore__cta"
            onClick={() => setShowViewMore(!showViewMore)}
          >
            {showViewMore ? "View More" : "View Less"}
          </a>
        </p>
      ) : null}
    </>
  );
}

export default function CrossLobLinks({
  crossLobSections,
  crossLobLinks,
  gridClassName = "grid4",
}: CrossLobLinksProps) {
  const sections = Array.isArray(crossLobSections)
    ? crossLobSections
    : Array.isArray(crossLobLinks)
    ? crossLobLinks
    : [];

  if (!sections.length) {
    return null;
  }

  return (
    <>
      {sections.map((section, index) => (
        <CrossLobSectionBlock
          key={`${section?.key || section?.title || "lob"}-${index}`}
          section={section}
          gridClassName={gridClassName}
        />
      ))}
    </>
  );
}
